import Element from "./index";
import { RouteType } from "routes/types";

const route: RouteType = {
  id: 1320,
  parentId: 1300,
  name: "JournalArticles",
  label: "Journal Articles",
  path: "journal_articles",
  element: Element,
  footer: true,
  user: false,
  admin: false,
  hidden: false,
};

export default route;
